import {APIResourceService} from '@/core/services/APIService'
import News from '@/core/resources/News'
import User from '@/core/resources/User'
import {TaskService} from '@/core/services/TaskService'
import {ServerService} from '@/core/services/ServerService'
import {CollectionService} from '@/core/services/CollectionService'
import {SpectraService} from '@/core/services/SpectraService'
import {RoleService} from '@/core/services/RoleService'
import {AuthService} from '@/core/services/AuthService'
import {PasswordService} from '@/core/services/PasswordService'
import {VersionService} from '@/core/services/VersionService'

export const newsService = new APIResourceService(News)
export const userService = new APIResourceService(User)
export const versionService = new VersionService()
export const roleService = new RoleService()
export const taskService = new TaskService()
export const serverService = new ServerService()
export const collectionService = new CollectionService()
export const spectraService = new SpectraService()
export const authService = new AuthService()
export const passwordService = new PasswordService()
